import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'sso';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_SSO_METADATA = createApiNamespacedConstants('get_sso_metadata');
export const UPDATE_SSO_METADATA = createApiNamespacedConstants('update_sso_metadata');
export const DELETE_SSO_METADATA = createApiNamespacedConstants('delete_sso_metadata');

// All types below belong to Global SSO managed via sso-service.
export const GET_SSO_CONFIG = createApiNamespacedConstants('GET_SSO_CONFIG');
export const UPDATE_SSO_CONFIG = createApiNamespacedConstants('UPDATE_SSO_CONFIG');
export const DELETE_SSO_CONFIG = createApiNamespacedConstants('DELETE_SSO_CONFIG');
export const CHECK_SSO_CONFIG_AVAILABLE = createApiNamespacedConstants('CHECK_SSO_CONFIG_AVAILABLE');
